import React, { useState,useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logo, EyeIcon, EyeSlashIcon } from '../assets/icons';
import ReCAPTCHA from 'react-google-recaptcha';


const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    const token = captchaRef.current?.getValue();
  // reCAPTCHA'yı sıfırla
  if (captchaRef.current) {
    captchaRef.current.reset(); // Güvenli ve önerilen yol
  } else if (typeof grecaptcha !== 'undefined') {
    //grecaptcha.reset(); // Alternatif olarak global nesne üzerinden
  }

    try {
     // const response = await loginRequest(username, password,captchaToken);
      await login({ username, password,token });
      navigate('/summary');
    } catch (error) {
      
      console.error('Login error:', error);
      var kod=error.status;
      switch (kod) {
        case 409:
          setError('Google reCAPTCHA doğrulama hatası.');
          break;
        case 404:
          setError('Kullanıcı adı veya parola yanlış.');
          break;
        case 405:
          setError('Çok fazla hatalı deneme yaptınız. 5 dk sonra tekrar deneyiniz.');
          break;
        case 401:
          setError('Kullanıcı adı veya parola yanlış.');
          break;
        default:
          setError('Hatalı giriş. Lütfen bilgilerinizi kontrol ediniz.');
          break;
      }
        } finally {
          setIsLoading(false);
        }
      };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <Logo width={230} height={180} />
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <input
            type="tel"
            placeholder="Kullanıcı TC"
            value={username}
            maxLength={11}
            onChange={(e) => setUsername(e.target.value)}
            disabled={isLoading}
          />
        </div>
        <div className="form-group password-input-group">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Parolanız"
            value={password}
            maxLength={24}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
          />
          <button
            type="button"
            className="password-toggle-button"
            onClick={togglePasswordVisibility}
            disabled={isLoading}
          >
            {showPassword ? <EyeSlashIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
          </button>
        </div>
        <ReCAPTCHA
        sitekey="6LeLOWAUAAAAAK5woF0zAAq9Nv0TJl1E-w5v-K7y"
        ref={captchaRef}
      />
        <button
          type="submit"
          className="login-button"
          disabled={isLoading}
        >
          Giriş Yap
        </button>
      </form>
    </div>
  );
};

export default Login; 